import { FC, Suspense, lazy } from "react";
import { useEffect } from "react";
import { Navigate, useNavigate, Route, Routes } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import PhanHeThongKe from "../modules/phan-he-thong-ke/PhanHeThongKe";
import { HomePage } from "../pages/Homepage/HomePage";
import { MenuTestPage } from "../pages/MenuTestPage";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import DanhMuc from "../modules/danh-muc/DanhMuc";
import KiemKe from "../modules/kiem-ke/KiemKe";
import { localStorageItem } from "../../app/modules/utils/LocalStorage";
import QuanlyCDT from "../modules/quan-ly-chi-dao-tuyen/QuanlyCDT";
import QuanlyKhaoSat from "../modules/quan-ly-khao-sat/QuanlyKhaoSat";
import QuanlyDaoTao from "../modules/quan-ly-dao-tao/QuanlyDaoTao";
import HoTroKyThuat from "../modules/ho-tro-ky-thuat/HoTroKyThuat";
import ChuyenGiaoKyThuat from "../modules/chuyen-giao-ky-thuat/ChuyenGiaoKyThuat";
import QuanlyKeHoach from "../modules/quan-ly-ke-hoach/QuanlyKeHoach";

const PrivateRoutes = () => {
  const navigate = useNavigate();
  const WizardsPage = lazy(() => import("../modules/wizards/WizardsPage"));
  const AccountPage = lazy(() => import("../modules/accounts/AccountPage"));
  const listMenu = localStorageItem.get("id-token-decode")?.menus?.["oceantech-doha-server"] || [];
  useEffect(() => {
    if (!listMenu?.[0]?.subs?.length) {
      navigate("/error/403");
    } else {
      // navigate(`${listMenu?.[0]?.subs?.[0]?.uri}`);
    }
  }, [listMenu[0]?.subs?.length])

  return (
    <Routes>
      <Route index element={<Navigate to={`${listMenu?.[0]?.subs?.[0]?.uri}`} />} />
      <Route path="/*" element={<Navigate to={`${listMenu?.[0]?.subs?.[0]?.uri}`} />} />
      {/* <Route index element={<Navigate to="/home" />} />
      <Route path="/*" element={<HomePage />} /> */}

      <Route path="home" element={<HomePage />} />
      <Route element={<MasterLayout />}>
        <Route path="auth/*" element={<Navigate to="/home" />} />
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />
        {/* <Route path="system/warehouse/statistics" element={<PhanHeThongKe />} /> */}
        {/* <Route path="system/warehouse/stocktaking" element={<KiemKe />} /> */}
        <Route path="doha/manage" element={<QuanlyCDT />} />
        <Route path="doha/category" element={<DanhMuc />} />
        <Route path="khao-sat" element={<QuanlyKhaoSat />} />
        <Route path="dao-tao" element={<QuanlyDaoTao />} />
        <Route path="ho-tro-ky-thuat" element={<HoTroKyThuat />} />
        <Route path="chuyen-giao-ky-thuat" element={<ChuyenGiaoKyThuat />} />
        <Route path="hoi-chan-tu-xa" element={<QuanlyDaoTao />} />
        <Route path="quan-ly-ke-hoach" element={<QuanlyKeHoach />} />
        {/* Lazy Modules */}
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route
          path="crafted/pages/wizards/*"
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path="crafted/account/*"
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>

  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--kt-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };

